import type { HexRenderContext } from './hexRenderTypes';
import { AbstractHex } from './AbstractHex';
import { getHexBounds } from './hexRenderUtils';

export class SettlementHex extends AbstractHex {
    protected drawOverlay(context: HexRenderContext): void {
        super.drawOverlay(context);
        const { ctx, verts, zoom } = context;
        const stripeHeight = 6 / zoom;
        const stripeGap = 4 / zoom;
        const stripeColor = 'rgba(88, 196, 122, 0.75)';
        const bounds = getHexBounds(verts);
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(verts[0].x, verts[0].y);
        for (let i = 1; i < verts.length; i += 1) ctx.lineTo(verts[i].x, verts[i].y);
        ctx.closePath();
        ctx.clip();

        ctx.fillStyle = stripeColor;
        let y = bounds.top;
        while (y < bounds.bottom) {
            ctx.fillRect(bounds.left, y, bounds.right - bounds.left, stripeHeight);
            y += stripeHeight + stripeGap;
        }
        ctx.restore();
    }
}
